export const operators = (type: string) => {
  return type === 'string'
    ? [
        { title: 'と一致', value: 'equals' },
        { title: 'と一致しない', value: 'not' },
        { title: '以上', value: 'gte' },
        { title: 'より大きい', value: 'gt' },
        { title: '以下', value: 'lte' },
        { title: 'より小さい', value: 'lt' },
        { title: 'を含む', value: 'contains' },
      ]
    : [
        { title: '以上', value: 'gte' },
        { title: '以下', value: 'lte' },
      ]
}

export const textFieldType = (type: string) => {
  switch (type) {
    case 'datetime':
      return 'datetime-local'
    case 'number':
      return 'number'
    default:
      return 'text'
  }
}
